/* eslint-disable @typescript-eslint/no-floating-promises */
import { Flex } from '@chakra-ui/react'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { iGraficoRespostasPorArea } from '../..'

interface BarChartProps {
  id: string
  data: iGraficoRespostasPorArea[]
}

export const BarChart: React.FC<BarChartProps> = ({ id, data }) => {
  function GerarGrafico(): void {
    const options = {
      series: [{
        data: data.map(e => e.qtd)
      }],
      chart: {
        type: 'bar',
        height: data.length * 50,
        width: 1000
      },
      colors: ['rgba(0, 153, 255, 0.9)', 'rgba(255, 153, 0, 0.9)', 'rgba(255, 80, 80, 0.9)', 'rgba(0, 180, 90, 0.9)', 'rgba(255, 204, 0, 0.9)',
        'rgba(0, 255, 153, 0.9)', 'rgba(102, 255, 255, 0.9)', 'rgba(0, 153, 153, 0.9)', 'rgba(204, 255, 102, 0.9)', 'rgba(155, 179, 255, 0.9)',
        'rgba(255, 135, 135, 0.9)', 'rgba(255, 255, 51, 0.9)', 'rgba(178, 101, 255, 0.9)', 'rgba(255, 228, 201, 0.9)', 'rgba(255, 255, 153, 0.9)', 'rgba(0, 153, 255, 0.9)', 'rgba(255, 153, 0, 0.9)', 'rgba(255, 80, 80, 0.9)', 'rgba(0, 180, 90, 0.9)', 'rgba(255, 204, 0, 0.9)',
        'rgba(0, 255, 153, 0.9)', 'rgba(102, 255, 255, 0.9)', 'rgba(0, 153, 153, 0.9)', 'rgba(204, 255, 102, 0.9)', 'rgba(155, 179, 255, 0.9)',
        'rgba(255, 135, 135, 0.9)', 'rgba(255, 255, 51, 0.9)', 'rgba(178, 101, 255, 0.9)', 'rgba(255, 228, 201, 0.9)', 'rgba(255, 255, 153, 0.9)'],
      tooltip: {
        enabled: true,
        y: {
          formatter: (seriesName: any) => seriesName,
          title: {
            formatter: () => ''
          }
        }
      },
      grid: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          },
          distributed: true,
          barHeight: '85%'
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -20
      },
      xaxis: {
        labels: {
          show: false
        },
        categories: data.map(e => e.area),
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [])
  return (
      <Flex id={`chart-${id}`} />
  )
}
